import { useParams } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { Message } from "primereact/message";
import { Breadcrumb, PageHeader } from "../../components/ui";
import { useGetBenefitByIdQuery } from "../../store/services/benefits";
import { BenefitForm } from "../../components/Forms/BenefitForm";

export const EditBenefit = () => {
  const { id } = useParams();
  const { data, isLoading, isError } = useGetBenefitByIdQuery(id || "", { skip: !id });

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Beneficios", to: "/benefits-catalog" },
          { label: data?.title ?? "Beneficio", to: id ? `/benefits-catalog/${id}` : undefined },
          { label: "Editar" },
        ]}
      />
    <div className="p-card gap-4 p-3">
      <PageHeader title="Editar Beneficio" />
      {isLoading ? (
        <div className="flex flex-column justify-content-center align-items-center gap-4 p-8">
          <ProgressSpinner />
        </div>
      ) : isError || !data ? (
        <div className="flex justify-content-center p-4">
          <Message
            severity="error"
            text="No se pudo cargar el beneficio. Intentá de nuevo en unos minutos."
          />
        </div>
      ) : (
        <BenefitForm benefitData={data} />
      )}
    </div>
    </>
  );
};
